import {FETCH_MEMBER_LIST, RECEIVE_MEMBER_LIST, FAILED_MEMBER_LIST} from '../../actions/satuan/aSatuan-MemberList'

const defaultMemberList = {
    memberList  : [],
    members     : []
}

export function fetchMemberList(state = defaultMemberList, action){
    switch(action.type){
        case FETCH_MEMBER_LIST:
            return({memberList: [], members:[], inProgress: true})
        case RECEIVE_MEMBER_LIST:
            var list = []
            action.payload.forEach((p, index) => {
                var bagian = {
                    'label': action.payload[index].rank + ' ' + action.payload[index].name,
                    'value': action.payload[index].id
                }
                list.push(bagian)
            })
            return Object.assign({}, state, {members:list,memberList: action.payload, inProgress: false})
        case FAILED_MEMBER_LIST:
            return({memberList: [], inProgress: false})
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/satuan/redSatuan-MemberList.jsx